const DAY_MS = 86_400_000;
const HIJRI_EPOCH_MS = Date.UTC(622, 6, 16);
const MEAN_YEAR_DAYS = 354.36707;
const MEAN_MONTH_DAYS = 29.530588;
let formatter = null;
function hijriFormatter() {
    if (!formatter) {
        formatter = new Intl.DateTimeFormat('en-u-ca-islamic-umalqura-nu-latn', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            timeZone: 'UTC',
        });
    }
    return formatter;
}
export function toHijri(date) {
    const parts = hijriFormatter().formatToParts(date);
    const read = (type) => Number(parts.find((part) => part.type === type)?.value ?? NaN);
    return { year: read('year'), month: read('month'), day: read('day') };
}
function compare(a, b) {
    return a.year - b.year || a.month - b.month || a.day - b.day;
}
export function fromHijri(year, month, day) {
    if (![year, month, day].every(Number.isInteger) || month < 1 || month > 12 || day < 1 || day > 30 || year < 1300 || year > 1600) {
        return null;
    }
    const target = { year, month, day };
    const estimate = HIJRI_EPOCH_MS + ((year - 1) * MEAN_YEAR_DAYS + (month - 1) * MEAN_MONTH_DAYS + (day - 1)) * DAY_MS;
    let low = Math.floor(estimate / DAY_MS) - 60;
    let high = Math.floor(estimate / DAY_MS) + 60;
    while (low <= high) {
        const middle = Math.floor((low + high) / 2);
        const candidate = new Date(middle * DAY_MS);
        const order = compare(toHijri(candidate), target);
        if (order === 0)
            return candidate;
        if (order < 0)
            low = middle + 1;
        else
            high = middle - 1;
    }
    return null;
}
//# sourceMappingURL=hijri.js.map